import { defineComponent, ref, watch, inject } from 'vue';
import { SeniorityLevel } from '@/shared/model/enumerations/seniority-level.model';
import { useI18N } from '@/plugins/i18n';
import StemdoerService from '@/sections/admin/entities/stemdoer/stemdoer.service';

export default defineComponent({
  props: {
    isOpen: { type: Boolean, required: true },
    onCloseModal: { type: Function, required: true },
    stemdoerId: { type: String, required: true },
    currentSeniority: { type: String, required: false },
    currentSeniorityLabel: { type: String, required: false }
  },
  components: {},
  setup(props, { emit }) {
    const i18n = useI18N();
    const stemdoerService: StemdoerService = inject('stemdoerService');

    const seniorityOptions = ref([
      { id: 'JUNIOR', desc: SeniorityLevel.JUNIOR },
      { id: 'MID_SENIOR', desc: SeniorityLevel.MID_SENIOR },
      { id: 'SENIOR', desc: SeniorityLevel.SENIOR }
    ]);

    const selectedSeniority = ref(props.currentSeniority || 'JUNIOR');

    const onSave = async () => {
      try {
        await stemdoerService.partialUpdateSeniority(props.stemdoerId, selectedSeniority.value);
        emit('seniority-updated', selectedSeniority.value);
        props.onCloseModal();
      } catch (err) {
        // Podrías mostrar un error aquí si lo deseas
      }
    };

    const onCancel = () => {
      props.onCloseModal();
    };

    const getSeniorityLabel = (id: string) => {
      switch (id) {
        case 'JUNIOR':
          return i18n.t('experienceLevel.explorer').toString();
        case 'MID_SENIOR':
          return i18n.t('experienceLevel.strategist').toString();
        case 'SENIOR':
          return i18n.t('experienceLevel.visionary').toString();
        default:
          return id;
      }
    };

    return {
      onSave,
      onCancel,
      seniorityOptions,
      selectedSeniority,
      currentSeniority: SeniorityLevel[props.currentSeniority as keyof typeof SeniorityLevel] || SeniorityLevel.JUNIOR,
      getSeniorityLabel
    };
  }
});
